import { call, put } from 'redux-saga/effects';
import { getAllEntries } from '../../services/entries-service';
import { setEntries } from './actions';

export const onGetAllEntries = function* ({ payload }) {
    const response = yield call(getAllEntries, payload);
    const site = response.items.map(item => item.fields).find(field => field.siteName === 'City Edition');
    yield put(setEntries(site.cityEdition));
}
